export enum SignalRConnectionStatus {
    Disconnected,
    Connected,
    Reconnecting
}
